'use strict';
export default ['personCodeValidator', (personCodeValidator) => {
    function isValidCode(code, country) {
        let validator = personCodeValidator.get(country);
        return !validator || validator.isValid(code);
    }

    function validateCode(code, country, ngModelCtrl) {
        let validator = personCodeValidator.get(country);

        if (!validator || validator.isValid(code)) {
            ngModelCtrl.$setValidity('person-code', true);
            return code;
        }

        ngModelCtrl.$setValidity('person-code', false);
        return undefined;
    }

    class PersonCodeDirective {
        restrict = 'A';
        require = 'ngModel';

        link(scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$validators['person-code'] = (viewValue) => {
                if (!attrs.personcode || !scope.$eval(attrs.personcode)) return viewValue;
                let country = scope.$eval(attrs.personcode);
                return isValidCode(viewValue, country);
            };

            scope.$watch(attrs.personcode, (country) => {
                let code = ngModelCtrl.$viewValue;
                let valid = isValidCode(code, country, ngModelCtrl);
                ngModelCtrl.$setValidity('person-code', valid);
                ngModelCtrl.$modelValue = valid ? code : undefined;
            });
        }
    }
    return new PersonCodeDirective();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/validation/person-code.directive.js